var map = {
	"./arrow-square-up.svg": 36,
	"./carousel.svg": 1669,
	"./empty-campaign.svg": 5829,
	"./empty-sites.svg": 5511,
	"./fileupload.svg": 9076,
	"./fund-bitcoin.svg": 5765,
	"./fund-card.svg": 6967,
	"./global.svg": 3186,
	"./icons/Telegram.svg": 9526,
	"./icons/facebook.svg": 3902,
	"./icons/game.svg": 1027,
	"./icons/global.svg": 3873,
	"./icons/instagram.svg": 673,
	"./icons/mobile.svg": 4881,
	"./icons/whatsapp.svg": 3881,
	"./image.svg": 6945,
	"./invoice.svg": 1416,
	"./lightning.svg": 5902,
	"./like.svg": 8841,
	"./logo-2.svg": 2534,
	"./logo.svg": 9574,
	"./moneys.svg": 6755,
	"./video.svg": 3815
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 968;